<div class="container">

  <mat-form-field appearance="fill">
    <textarea matInput title="Descricao"></textarea>
  </mat-form-field>

</div>